import React from 'react';
import { useTranslation } from 'react-i18next';
import Divider from 'components/Divider/Divider';
import { BoldSubtitle } from 'components/Text';
import useStyles from './RemittanceListStyles';
import RemittanceRow from './RemittanceRow';
export default function RemittanceList({
  items
}) {
  const {
    t
  } = useTranslation();
  const {
    details,
    column
  } = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: details
  }, /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('remittance.details.type'))), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('remittance.details.description'))), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('remittance.details.vat_basis'))), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('remittance.details.vat'))), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('remittance.details.price')))), items?.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.id
  }, /*#__PURE__*/React.createElement(RemittanceRow, item), /*#__PURE__*/React.createElement(Divider, null))));
}